import { math } from 'polished';
import styled, { css, keyframes } from 'styled-components';
import { iconNextSizeVariant } from '@clds/icon';
import { spinnerVariant } from './theme.js';
const rotation = keyframes `
   from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
`;
const sizeMixin = (props) => math(`${iconNextSizeVariant(props.size).width} / ${spinnerVariant(props.spinnerVariant)}`);
const iconMixin = (props) => {
    const size = props.size ? iconNextSizeVariant(props.size).width : '100%';
    return css `
    width: ${size};
    height: ${size};
  `;
};
// eslint-disable-next-line import/no-default-export
export default styled.div(({ theme, size, variant, color }) => {
    // @ts-expect-error TODO fix after migration
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const finalColor = theme[color] || theme.palette[variant];
    return css `
    ${iconMixin({
        size: size ?? 'md',
        variant: variant ?? 'primary',
        color: finalColor,
    })};
    animation: ${rotation} 1s infinite linear;
    border-radius: 100%;

    &:before {
      content: '';
      display: block;
      position: absolute;
      height: 100%;
      width: 100%;
      border-top: ${sizeMixin} solid ${finalColor};
      border-left: ${sizeMixin} solid ${finalColor};
      border-bottom: ${sizeMixin} solid ${finalColor};
      border-right: ${sizeMixin} solid transparent;
      border-radius: 100%;
    }
  `;
});
